<script>
    import jQuery from "jquery";
    import {getGPTransFunc} from "./gp-translations.js";
    import {GPMisc} from "./gp-misc";
    let trans = getGPTransFunc("gp-keyboardshortcuts");

    let shortcut;

    let shortCutForBrowser = {
        "win_ff" : "Alt+Shift",
        "win_ie" : "Alt",
        "win_chrome" : "Alt",
        "win_safari" : "Alt",
        "win_opera" : "Alt",
        "win_edge" : "Alt",
        "mac_ff" : "Control+Alt",
        "mac_chrome" : "Control+Alt",
        "mac_safari" : "Control+Alt",
        "mac_opera" : "Control+Alt"
    }
    
    export function open() {
        shortcut = shortCutForBrowser[GPMisc.detectOS() + "_" + GPMisc.detectBrowser()];

        //manage focus
        jQuery('#GPKeyboardShortcuts').on('show.bs.modal', GP.storeFocus);
        jQuery('#GPKeyboardShortcuts').on('shown.bs.modal',function (){jQuery('#GPKeyboardShortcuts .close').focus();});
        jQuery('#GPKeyboardShortcuts').on('hidden.bs.modal', GP.restoreFocus);

        //trap focus
        jQuery('#GPKeyboardShortcuts .close').on('keydown', function(e) {if (e.shiftKey && e.which===9) e.preventDefault();});
        jQuery('#GPKeyboardShortcuts .close').on('keydown', function(e) {if (!e.shiftKey && e.which===9) e.preventDefault();});

        jQuery('#GPKeyboardShortcuts').modal({});
    }


</script>

<div class="modal fade GPModal" tabindex="-1" id="GPKeyboardShortcuts">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                <h4 class="modal-title">{trans("Keyboard shortcuts")}</h4>
            </div>
            <div class="modal-body">
                <ul class="GPKeyshortcutsList">
                    <li><span class="GPShortcutKeys"><span class="GPShortcutKey">tab</span><span class="GPShortcutKey">shift+tab</span> </span><span class="GPShortcutDesc">{trans("Next/prev app control")}</span></li>
                    <li><span class="GPShortcutKeys"><span class="GPShortcutKey">space</span> </span><span class="GPShortcutDesc">{trans("Add plant or structure to project")}</span></li>
                    <li><span class="GPShortcutKeys"><span class="GPShortcutKey">&larr;</span><span class="GPShortcutKey">&uarr;</span><span class="GPShortcutKey">&rarr;</span><span class="GPShortcutKey">&darr;</span></span> <span class="GPShortcutDesc">{@html trans("Browse plant/structure list<br/>Move selected plant or structure around project<br/>Control texture cursor (+shift to apply texture)")}</span></li>
                    <li><span class="GPShortcutKeys"><span class="GPShortcutKey">PageUp</span><span class="GPShortcutKey">PageDown</span></span> <span class="GPShortcutDesc">{trans("Select plant or structure already placed on the project")}</span></li>
                    <li><span class="GPShortcutKeys"><span class="GPShortcutKey">del</span> </span><span class="GPShortcutDesc">{trans("Delete selected item")}</span></li>
                    <li><span class="GPShortcutKeys"><span class="GPShortcutKey">+</span><span class="GPShortcutKey">-</span> </span><span class="GPShortcutDesc">{trans("Resize selected item")}</span></li>
                    <li><span class="GPShortcutKeys"><span class="GPShortcutKey">?</span> </span><span class="GPShortcutDesc">{trans("More info about selected item")}</span></li>
                    <li><span class="GPShortcutKeys"><span class="GPShortcutKey">esc</span> </span><span class="GPShortcutDesc">{@html trans("Deselect item <br/> Close current dialog")}</span></li>
                </ul>
                <hr/>
                <ul class="GPKeyshortcutsList">
                    <li><span class="GPShortcutKeys"><span class="GPShortcutKey">{shortcut}+b</span></span> <span class="GPShortcutDesc">{trans("Change scenery (background)")}</span></li>
                    <li><span class="GPShortcutKeys"><span class="GPShortcutKey">{shortcut}+o</span></span> <span class="GPShortcutDesc">{trans("Open")}</span></li>
                    <li><span class="GPShortcutKeys"><span class="GPShortcutKey">{shortcut}+s</span></span> <span class="GPShortcutDesc">{trans("Save")}</span></li>
                    <li><span class="GPShortcutKeys"><span class="GPShortcutKey">{shortcut}+n</span> </span><span class="GPShortcutDesc">{trans("New")}</span></li>
                    <li><span class="GPShortcutKeys"><span class="GPShortcutKey">{shortcut}+z</span> </span><span class="GPShortcutDesc">{trans("Undo")}</span></li>
                </ul>
            </div>
        </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
</div><!-- /.modal -->